export const INTRANET_FEED_VIEW_KEY = 'intranet.feed.view';

export type IntranetFeedView = 'list' | 'grid';

/** Tailwind `md` — grid layout and the list/raster toggle are desktop-only. */
export const INTRANET_FEED_GRID_LAYOUT_QUERY = '(min-width: 768px)';

/** Stored choice wins from `md` up. Below that, the feed is always a list. */
export function readIntranetFeedView(storage: Pick<Storage, 'getItem'> | null): IntranetFeedView {
  const value = storage?.getItem(INTRANET_FEED_VIEW_KEY);
  return value === 'grid' ? 'grid' : 'list';
}

export function effectiveIntranetFeedView(
  view: IntranetFeedView,
  gridLayoutAvailable: boolean,
): IntranetFeedView {
  return gridLayoutAvailable ? view : 'list';
}

export function writeIntranetFeedView(
  storage: Pick<Storage, 'setItem'> | null,
  view: IntranetFeedView,
): void {
  storage?.setItem(INTRANET_FEED_VIEW_KEY, view);
}
